module.exports = __webpack_public_path__ + "ffca23df084a9c2ae0e1afb64db2c6f6.svg";